import React, { useEffect, useState } from 'react';
import { fetchPatientSurveyList } from '../adapters/fetchPatientSurveyList';
import Cookies from 'js-cookie';

const useGetPatientSurveyList = (formFilter) => {
  const [loading, setLoading] = useState('loading');
  const [data, setData] = useState();

  const idPatient = Cookies.get('user')
    ? JSON.parse(Cookies.get('user'))?.IdPatient
    : null;

  // console.log(
  //   'formFilterformFilterformFilterformFilter->',
  //   formFilter
  // );

  useEffect(() => {
    if (idPatient) {
      fetchPatientSurveyList(
        setLoading,
        idPatient,
        setData,
        formFilter
      );
    }
  }, [idPatient, formFilter]);

  return loading || data;
};

export default useGetPatientSurveyList;
